import { baseApi, client } from 'api/baseApi.ts';

export const charactersEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCharacters: builder.query({
			queryFn: async ({
				page = 1,
				pageSize = 10,
				type,
			}: { page?: number; pageSize?: number; type?: string } = {}) => {
				const request = { page, page_size: pageSize, ...(type && { type }) };
				const response = await client.characters.list(request);
				return { data: { data: response.data, pagination: response.pagination } };
			},
			// providesTags: ['Characters'],
			providesTags: (result, error, args) =>
				result
					? [
							{ type: 'Characters', id: `PARTIAL-LIST-${args.page}` },
							...(result?.data ?? []).map(({ id }) => ({ type: 'Characters' as const, id })),
						]
					: [{ type: 'Characters', id: `PARTIAL-LIST-${args.page}` }],
		}),
		updateCharacter: builder.mutation({
			queryFn: async ({ characterId, request }: { characterId: string; request: any }) => {
				const response = await client.characters.update(characterId, request);
				return { data: response.data };
			},
			invalidatesTags: () => [{ type: 'Characters', id: `PARTIAL-LIST-1` }],
		}),

		createCharacter: builder.mutation({
			queryFn: async ({ request }) => {
				const response = await client.characters.create(request);
				return { data: response.data };
			},
			invalidatesTags: [{ type: 'Characters', id: `PARTIAL-LIST-1` }],
		}),

		deleteCharacter: builder.mutation({
			queryFn: async ({ characterIds }: { characterIds: string[] }) => {
				const response = await client.characters.delete({ character_ids: characterIds });
				return { data: response.data };
			},
			invalidatesTags: (result, error, args) => [
				...args.characterIds.map((id) => ({ type: 'Characters' as const, id })),
			],
		}),
	}),
});
